import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { idiomas } from './idiomas.js'

Vue.use(VueI18n)

export const i18n = new VueI18n({
	locale: 'en-GB', // set locale
	fallbackLocale: 'es-ES',
	messages: idiomas
})